import React from 'react';

const ExperimentIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16698 17.5C3.45865 17.5 2.95518 17.184 2.65657 16.5521C2.35796 15.9201 2.43087 15.3333 2.87532 14.7917L7.50032 9.16667V4.16667H6.66698C6.43087 4.16667 6.23296 4.08681 6.07323 3.92708C5.91351 3.76736 5.83365 3.56944 5.83365 3.33333C5.83365 3.09722 5.91351 2.89931 6.07323 2.73958C6.23296 2.57986 6.43087 2.5 6.66698 2.5H13.3337C13.5698 2.5 13.7677 2.57986 13.9274 2.73958C14.0871 2.89931 14.167 3.09722 14.167 3.33333C14.167 3.56944 14.0871 3.76736 13.9274 3.92708C13.7677 4.08681 13.5698 4.16667 13.3337 4.16667H12.5003V9.16667L17.1253 14.7917C17.5698 15.3333 17.6427 15.9201 17.3441 16.5521C17.0455 17.184 16.542 17.5 15.8337 17.5H4.16698ZM5.83365 15H14.167L11.3337 11.6667H8.66698L5.83365 15Z"
        fill="#0276FE"
      />
    </svg>
  );
};

export default ExperimentIcon;
